import vuetify from '@/plugins/vuetify';

/**
 * Sync Vuex isDarkMode → Vuetify 3 theme (replaces Vue 2 $darkMode prototype).
 */
export function setDarkMode(isDark) {
  vuetify.theme.change(isDark ? 'dark' : 'light');
}

export function installDarkModeHelper(app) {
  app.config.globalProperties.$setDarkMode = setDarkMode;

  Object.defineProperty(app.config.globalProperties, '$darkMode', {
    get() {
      return vuetify.theme.global.name.value === 'dark';
    },
    set(value) {
      setDarkMode(value);
    },
  });
}

/**
 * Minimal cookie read for SignUp affiliate tid tracking (vue-cookies deferred).
 * Prefer _wwaff_tid; fall back to legacy _fprom_tid during FirstPromoter cutover.
 */
export function installCookiesStub(app) {
  app.config.globalProperties.$cookies = {
    get(key) {
      const match = document.cookie.match(new RegExp(`(?:^|; )${key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
      return match ? decodeURIComponent(match[1]) : null;
    },
    set() {},
    remove() {},
  };
}
